
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("4nPqP", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.7dd158b3.js.map
